var _path, _path2, _ellipse, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigCone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.5,
    height: 35.5,
    viewBox: "0 0 67 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0211 11.7578C29.4648 7.77393 35.099 7.77393 36.5427 11.7578L49.3768 47.1741C50.4476 50.1289 48.2589 53.25 45.116 53.25H19.4478C16.3049 53.25 14.1162 50.1289 15.187 47.1741L28.0211 11.7578Z",
    fill: "#FF7D06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66896 51.2601L11.534 46.3444C11.8942 46.1193 12.3103 46 12.735 46H52.633C53.037 46 53.4336 46.108 53.7818 46.3129L62.1765 51.2509C63.7874 52.1984 63.6232 54.5789 61.8975 55.2963L33.3637 67.1587C32.798 67.3939 32.1611 67.39 31.5983 67.1478L3.9744 55.2631C2.295 54.5406 2.11863 52.2291 3.66896 51.2601Z",
    fill: "#FF7D06"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2818,
    cy: 49.4734,
    rx: 16.9947,
    ry: 7.17553,
    fill: "#FF7D06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15L17 45.5",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15L47 45.5",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCone);
export default __webpack_public_path__ + "static/media/big-cone.459784868f060bef0a46377704c57202.svg";
export { ForwardRef as ReactComponent };